export default __webpack_public_path__ + "static/media/play-kids.c7d1bd99.svg";